import * as Sentry from '@sentry/react';

import { SENTRY_DEBUG, SENTRY_ENABLED } from '../constants/sentry';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_NODE_ENV,
  enabled: SENTRY_ENABLED,
  debug: SENTRY_DEBUG,
  integrations: [Sentry.replayIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
